import React from 'react';
import PropTypes from 'prop-types';

export default function IconChatty({size = '55px', color = '#303030'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.87713 0.0917969C2.5487 0.0917969 0.661133 1.97936 0.661133 4.30779V10.3598C0.661133 12.6882 2.5487 14.5758 4.87713 14.5758H16.9051C18.8952 14.6617 20.5592 16.0055 21.122 17.8321C21.1357 17.8767 21.1767 17.9077 21.2234 17.9077C21.2813 17.9077 21.3283 17.8607 21.3283 17.8028V10.5643C21.3315 10.4965 21.3331 10.4284 21.3331 10.3598V4.3078C21.3331 1.97936 19.4456 0.0917969 17.1171 0.0917969H4.87713Z"
        fill="white"
      />
      <rect x="4.87695" y="4.7832" width="2.584" height="4.42" rx="1.292" fill={color} />
      <rect x="10.998" y="4.7832" width="2.584" height="4.42" rx="1.292" fill={color} />
    </svg>
  );
}

IconChatty.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
